import { deleteRequest, get, patch, post } from "../utils/api";

export const updateAddressMultiple = (data) => {
  return patch(`/address/multiple`, data);
};

export const getAddressList = () => {
  return get(`/address`);
};

/** Reference data for forms (auth required). */
export const getAddressCountries = () => {
  return get(`/address/countries`);
};

/** @param {string} countryIso2 e.g. "IN" */
export const getAddressStates = (countryIso2) => {
  return get(`/address/states`, { country: countryIso2 });
};

/** @param {string} countryIso2 @param {string} stateIso e.g. "GJ" */
export const getAddressCities = (countryIso2, stateIso) => {
  return get(`/address/cities`, { country: countryIso2, state: stateIso });
};

export const addAddress = (data) => {
  return post(`/address`, data);
};

export const updateAddress = (data) => {
  const id = data?.id;
  delete data.id;
  return patch(`/address/${id}`, data);
};
export const deleteAddress = (data) => {
  const id = data?.id;
  delete data.id;
  return deleteRequest(`/address/${id}`, data);
};
export const addressApi = {
  updateAddressMultiple,
  getAddressList,
  getAddressCountries,
  getAddressStates,
  getAddressCities,
  addAddress,
  updateAddress,
  deleteAddress
};
